<div class="previewBoard">
  <div class="preview-content">
    <svg-icon *ngIf="!static" [height]="80" [width]="65" icon="pdf-file"></svg-icon>
    <svg-icon *ngIf="static" [height]="iconHeight$ | async" icon="pdf-file"></svg-icon>
    <ng-content></ng-content>
    <p class="zoom-title-content" *ngIf="!static && !isLoading">
      <span>{{ 'Zoom-in to view PDF' | translate }}</span>
    </p>
  </div>
</div>
